import React, { useEffect } from 'react';
import { RailsBlock } from '@sls-react/typings/services/rails/tile';
import Image from '@sls-react/components/Image';
import useTileVersions from '@sls-react/hooks/useTileVersions';
import useCarousel from '@sls-react/hooks/useCarousel';
import SwipeableViewsWithIndicators from '@sls-react/components/Swipeable/SwipeableViewsWithIndicators';
import useMobile from '@sls-react/hooks/useMobile';

interface Props {
  block: RailsBlock;
}

const ShortHeroBlock: React.FC<Props> = ({ block }) => {
  const tiles = useTileVersions(block);
  const mobile = useMobile();
  const { index, setIndex, goToNextIndex } = useCarousel(tiles?.length || 0);
  const height = mobile ? 140 : 200;

  useEffect(() => {
    const timeout = setTimeout(goToNextIndex, 5000);
    return () => clearTimeout(timeout);
  }, [goToNextIndex, index]);

  return (
    <SwipeableViewsWithIndicators index={index} onChangeIndex={setIndex}>
      {tiles?.map(tile => (
        <a
          key={tile.id}
          href={tile.destination}
          className="relative block"
          style={{
            backgroundColor: tile.background_color || undefined,
            height,
          }}
          title={tile.title}
        >
          <Image
            alt={tile.title}
            src={tile.background_image_url}
            className="absolute block object-contain w-full h-full"
            useFastly={{
              height: 300,
            }}
          />
        </a>
      ))}
    </SwipeableViewsWithIndicators>
  );
};

export default ShortHeroBlock;
